import { render, staticRenderFns } from "./Bancolombia.vue?vue&type=template&id=3a949206"
import script from "./Bancolombia.vue?vue&type=script&lang=js"
export * from "./Bancolombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports